import { useContext, useEffect } from 'react'
import { AppData, AppDispatch } from './Model'
import cancelSign from './assets/cancel.svg'

export function Picture() {
	const state = useContext(AppData)
	const dispatch = useContext(AppDispatch)

	const cancel = () => dispatch({ type: 'picture', value: null })

	if (!state.picture) return null

	const { path } = state.picture

	return (
		<div className='picture-gallery' onClick={cancel}>
			<button onClick={cancel} className='cancel'><img src={cancelSign} alt='Cancel' /></button>
			<img className='single-picture' src={path} onClick={event => event.stopPropagation()} alt='Full-size' />
		</div>
	)
}

export function Gallery() {
	const state = useContext(AppData)
	const dispatch = useContext(AppDispatch)

	const open = (path, index) => dispatch({ type: 'picture', value: { path, gallery, index } })
	const cancel = () => dispatch({ type: 'gallery', value: null })

	if (!state.gallery) return null

	const gallery = state.galleries[state.gallery]


	return (
		<div className='picture-gallery' onClick={cancel}>
			<button onClick={cancel} className='cancel'><img src={cancelSign} alt='Cancel' /></button>
			<div className='grid' onClick={event => event.stopPropagation()}>
				{gallery.data.map((picture, i) => (
					<img key={i} src={`${gallery.path}/${picture}`} onClick={() => open(`${gallery.path}/${picture}`, i)} alt='Link to full-size' />
				))}
			</div>
		</div>
	)
}

export function useKeypress(key, callback) {
	useEffect(() => {
		const handler = event => { if (event.key === key) callback(event) }
		document.addEventListener('keypress', handler)
		return () => document.removeEventListener('keypress', handler)
	}, [ key, callback ])
}

export function Popover() {
	const state = useContext(AppData)
	const dispatch = useContext(AppDispatch)

	const cancel = () => dispatch({ type: 'announcement', value: null })

	if (!state.announcement) return null

	return (
		<div className='popover' onClick={cancel}>
			<div className='card' onClick={event => event.stopPropagation()}>

				<state.announcement />

				<div className='card-options'>
					<button onClick={cancel}>Close</button>
				</div>
			</div>
		</div>
	)
}
